// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3V-Cq","productName":"Table_productName__2Ioyy"};